// import React, { useState, useEffect, useRef } from 'react';
// import {
//   Container,
//   Typography,
//   Grid,
//   TextField,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   TextareaAutosize,
//   Button,
// } from '@mui/material';
// import TClientes from '../../GestionDeClientes/Clientes/TClientes';
// import style from '../../Tools/Style.js';
// import { editarCampana } from '../../../actions/CampanasAction';
// import { useStateValue } from '../../../contexto/store';
// import { RegistrarAccion } from '../../../actions/AuditoriaAction';
// export function PerfilCampana(props) {
//   //eslint-disable-next-line
//   const [{ openSnackBar, sesionUsuario }, dispatch] = useStateValue();
//   const mounted = useRef(true);
//   const [geografia, setGeografia] = useState('');
//   const [Datag, setDatag] = useState([]);
//   const [estadocampana, sertEstadoCampana] = useState('');
//   const [estadoBotonClientes, setEstadoBotonClientes] = useState(false);
//   const [DataCli, setDataCli] = useState([]);
//   const [campana, setCampana] = useState({
//     id: '',
//     CODCAMPANA: 0,
//     DESCRICAMPANA: '',
//     NUMCAMPANA: '',
//     ESTADOCAMPANA: '',
//     EMPRESACONTRATADA: '',
//     OBJETIVOS: '',
//     PRESUPUESTO: '',
//   });
//   const selectGeografiaHandleChange = (event) => {
//     setGeografia(event.target.value);
//   };
//   const selectEstadohandleChange = (event) => {
//     sertEstadoCampana(event.target.value);
//   };
//   const ingresarValoresMemoria = (e) => {
//     const { name, value } = e.target;
//     setCampana((anterior) => ({
//       ...anterior,
//       [name]: value,
//     }));
//   };
//   const mostrarClientes = () => {
//     if (estadoBotonClientes === false) {
//       setEstadoBotonClientes(true);
//     } else {
//       setEstadoBotonClientes(false);
//     }
//   };
//   const modificarCampana = (e) => {
//     e.preventDefault();
//     const objetoModCampana = {
//       CODCAMPANA: parseInt(campana.CODCAMPANA),
//       DESCRICAMPANA: campana.DESCRICAMPANA,
//       ESTADOCAMPANA: estadocampana,
//       EMPRESACONTRATADA: campana.EMPRESACONTRATADA,
//       GEOGRAFIA: geografia,
//       OBJETIVOS: campana.OBJETIVOS,
//       PRESUPUESTO: parseInt(campana.PRESUPUESTO),
//     };
//     editarCampana(campana.id, objetoModCampana).then((response) => {
//       if (response.status === 200) {
//         dispatch({
//           type: 'OPEN_SNACKBAR',
//           openMensaje: {
//             open: true,
//             mensaje: 'Se modifico exitosamente la Campaña',
//           },
//         });
//         setCampana({
//           id: '',
//           CODCAMPANA: 0,
//           DESCRICAMPANA: '',
//           NUMCAMPANA: '',
//           ESTADOCAMPANA: '',
//           EMPRESACONTRATADA: '',
//           OBJETIVOS: '',
//           PRESUPUESTO: 0.0,
//         });
//         let objetoAudi = {
//           usuario: sesionUsuario.usuario.nombrecompleto,
//           accion: 'Modificacion',
//           panel: 'Marketing',
//           tabla: 'CAMPAÑAS',
//           filaafectada: props.location.state.clientE_Id,
//           UsuarioId: sesionUsuario.usuario.id,
//         };
//         RegistrarAccion(objetoAudi);
//         volver();
//       } else {
//         dispatch({
//           type: 'OPEN_SNACKBAR',
//           openMensaje: {
//             open: true,
//             mensaje: 'Errores al intentar guardar ',
//           },
//         });
//       }
//     });
//   };
//   const volver = () => {
//     props.history.goBack();
//   };
//   useEffect(() => {
//     if (mounted.current) {
//       setCampana({
//         id: props.location.state.campanA_Id,
//         CODCAMPANA: props.location.state.codcampana,
//         DESCRICAMPANA: props.location.state.descricampana,
//         NUMCAMPANA: props.location.state.numcampana,
//         ESTADOCAMPANA: props.location.state.estadocampana,
//         EMPRESACONTRATADA: props.location.state.empresacontratada,
//         OBJETIVOS: props.location.state.objetivos,
//         PRESUPUESTO: props.location.state.presupuesto,
//       });
//       setDataCli(props.location.state.clientesLista);
//       setDatag([
//         { geografia: 'Local' },
//         { geografia: 'Regional' },
//         { geografia: 'Nacional' },
//         { geografia: 'Internacional' },
//       ]);
//     }
//     return function cleanup() {
//       mounted.current = false;
//     };
//   }, [props]);
//   return (
//     <Container component="main" maxWidth="md" justify="center">
//       <div style={style.paper}>
//         <br></br>
//         <br></br>
//         <Typography component="h1" variant="h6">
//           Modificar Campana
//         </Typography>
//         <br></br>
//         <br></br>
//         <form style={style.form}>
//           <Grid container spacing={4}>
//             <Grid item xs={12} md={6}>
//               <TextField
//                 multiline
//                 name="CODCAMPANA"
//                 value={campana.CODCAMPANA}
//                 fullWidth
//                 onChange={ingresarValoresMemoria}
//                 variant="outlined"
//                 label="Codigo"
//               />
//             </Grid>

//             <Grid item xs={12} md={6}>
//               <TextField
//                 multiline
//                 name="DESCRICAMPANA"
//                 value={campana.DESCRICAMPANA}
//                 fullWidth
//                 onChange={ingresarValoresMemoria}
//                 variant="outlined"
//                 label="Descripcion"
//               />
//             </Grid>
//             <Grid item xs={12} md={6}>
//               <FormControl variant="outlined" fullWidth>
//                 <InputLabel id="demo-simple-select-outlined-label">
//                   Estado
//                 </InputLabel>
//                 <Select
//                   labelId="demo-simple-select-outlined-label"
//                   id="demo-simple-select-outlined"
//                   value={estadocampana}
//                   onChange={selectEstadohandleChange}
//                   label="Estado"
//                 >
//                   <MenuItem value="Activo">
//                     <em>Activo</em>
//                   </MenuItem>
//                   <MenuItem value="Inactivo">
//                     <em>Inactivo</em>
//                   </MenuItem>
//                 </Select>
//               </FormControl>
//             </Grid>
//             <Grid item xs={12} md={6}>
//               <TextField
//                 multiline
//                 name="EMPRESACONTRATADA"
//                 value={campana.EMPRESACONTRATADA}
//                 fullWidth
//                 onChange={ingresarValoresMemoria}
//                 variant="outlined"
//                 label="Empresa Contratada"
//               />
//             </Grid>
//             <Grid item xs={12} md={6}>
//               <FormControl variant="outlined" fullWidth>
//                 <InputLabel id="demo-simple-select-outlined-label">
//                   Geografia
//                 </InputLabel>
//                 <Select
//                   labelId="demo-simple-select-outlined-label"
//                   id="demo-simple-select-outlined"
//                   value={geografia}
//                   onChange={selectGeografiaHandleChange}
//                   label="Geografia"
//                 >
//                   <MenuItem value="">
//                     <em>Ninguna</em>
//                   </MenuItem>
//                   {Datag.map((geografia) => (
//                     <MenuItem
//                       key={geografia.geografia}
//                       value={geografia.geografia}
//                     >
//                       {geografia.geografia}
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid>
//             <Grid item xs={12} md={6}>
//               <TextField
//                 multiline
//                 name="OBJETIVOS"
//                 value={campana.OBJETIVOS}
//                 fullWidth
//                 onChange={ingresarValoresMemoria}
//                 variant="outlined"
//                 label="Objetivos"
//               />
//             </Grid>
//             <Grid item xs={12} md={6}>
//               <TextField
//                 multiline
//                 name="PRESUPUESTO"
//                 value={campana.PRESUPUESTO}
//                 fullWidth
//                 onChange={ingresarValoresMemoria}
//                 variant="outlined"
//                 label="Presupuesto"
//               />
//             </Grid>
//           </Grid>
//           <br></br>
//           <Grid>
//             <TextareaAutosize
//               name="NUMCAMPANA"
//               value={campana.NUMCAMPANA}
//               onChange={ingresarValoresMemoria}
//               style={style.textarea}
//               variant="outlined"
//               rowsMin={4}
//               placeholder="Detalles"
//             />
//           </Grid>
//           <br></br>
//           <br></br>
//           <Grid container spacing={4} justify="center">
//             <Grid item xs={12} md={6}>
//               <Button
//                 variant="contained"
//                 color="primary"
//                 onClick={modificarCampana}
//                 style={style.submit}
//                 type="submit"
//               >
//                 Guardar
//               </Button>
//             </Grid>
//             <Grid item xs={12} md={6}>
//               <Button
//                 variant="contained"
//                 color="primary"
//                 onClick={volver}
//                 style={style.submit}
//               >
//                 Volver
//               </Button>
//             </Grid>
//             <Button
//               variant="contained"
//               fullWidth
//               color="primary"
//               onClick={mostrarClientes}
//               style={style.notifications}
//             >
//               Clientes Ganados por esta Campaña
//             </Button>
//           </Grid>
//         </form>
//       </div>
//       <Grid item md={12} lg={12}>
//         {estadoBotonClientes === true ? (
//           <div>
//             <br />
//             <br />
//             <TClientes rows={DataCli} termc={''} />
//           </div>
//         ) : null}
//       </Grid>
//     </Container>
//   );
// }


import React, { useState, useEffect, useRef } from 'react';
import {
  Container,
  Typography,
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Paper,
  Box,
} from '@mui/material';
import CampaignIcon from '@mui/icons-material/Campaign';
import SaveIcon from '@mui/icons-material/Save';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import PeopleIcon from '@mui/icons-material/People';
import TClientes from '../../GestionDeClientes/Clientes/TClientes';
import { editarCampana } from '../../../actions/CampanasAction';
import { useStateValue } from '../../../contexto/store';
import { RegistrarAccion } from '../../../actions/AuditoriaAction';
import { obtenerClientesPorCampana } from '../../../actions/CampanasAction';

export function PerfilCampana(props) {
  //eslint-disable-next-line
  const [{ openSnackBar, sesionUsuario }, dispatch] = useStateValue();
  const mounted = useRef(true);
  const [geografia, setGeografia] = useState('');
  const [Datag, setDatag] = useState([]);
  const [estadocampana, sertEstadoCampana] = useState('');
  const [estadoBotonClientes, setEstadoBotonClientes] = useState(false);
  const [DataCli, setDataCli] = useState([]);
  const [campana, setCampana] = useState({
    id: '',
    CODCAMPANA: 0,
    DESCRICAMPANA: '',
    NUMCAMPANA: '',
    ESTADOCAMPANA: '',
    EMPRESACONTRATADA: '',
    OBJETIVOS: '',
    PRESUPUESTO: '',
  });
  const selectGeografiaHandleChange = (event) => {
    setGeografia(event.target.value);
  };
  const selectEstadohandleChange = (event) => {
    sertEstadoCampana(event.target.value);
  };
  const ingresarValoresMemoria = (e) => {
    const { name, value } = e.target;
    setCampana((anterior) => ({
      ...anterior,
      [name]: value,
    }));
  };
  // const mostrarClientes = () => {
  //   if (estadoBotonClientes === false) {
  //     setEstadoBotonClientes(true);
  //     // Aqui llamamos a la accion de la API para traer la lista de clientes
  //     // del lado del backend.
  //     obtenerClientesGanados(campana.id).then(response => {
  //       if (response.status === 200) {
  //         setDataCli(response.data);
  //       } else {
  //         dispatch({
  //           type: 'OPEN_SNACKBAR',
  //           openMensaje: {
  //             open: true,
  //             mensaje: 'Errores al obtener los clientes de la campaña',
  //           },
  //         });
  //       }
  //     });
  //   } else {
  //     setEstadoBotonClientes(false);
  //   }
  // };
  const mostrarClientes = () => {
    if (estadoBotonClientes === false) {
        setEstadoBotonClientes(true);
        obtenerClientesPorCampana(campana.id).then(response => {
            if (response.status === 200) {
                //  Verificar que la respuesta es un array antes de actualizar el estado
                if (Array.isArray(response.data)) {
                    setDataCli(response.data);
                } else {
                    // Si la respuesta no es un array, establecer un array vacío
                    setDataCli([]);
                    dispatch({
                        type: 'OPEN_SNACKBAR',
                        openMensaje: {
                            open: true,
                            mensaje: 'La API no devolvió una lista de clientes válida.',
                        },
                    });
                }
            } else {
                setDataCli([]); // Limpiar la lista de clientes en caso de error
                dispatch({
                    type: 'OPEN_SNACKBAR',
                    openMensaje: {
                        open: true,
                        mensaje: 'Errores al obtener los clientes de la campaña',
                    },
                });
            }
        });
    } else {
        setEstadoBotonClientes(false);
    }
};
  const modificarCampana = (e) => {
    e.preventDefault();
    const objetoModCampana = {
      CODCAMPANA: parseInt(campana.CODCAMPANA),
      DESCRICAMPANA: campana.DESCRICAMPANA,
      ESTADOCAMPANA: estadocampana,
      EMPRESACONTRATADA: campana.EMPRESACONTRATADA,
      GEOGRAFIA: geografia,
      OBJETIVOS: campana.OBJETIVOS,
      PRESUPUESTO: parseInt(campana.PRESUPUESTO),
    };
    editarCampana(campana.id, objetoModCampana).then((response) => {
      if (response.status === 200) {
        dispatch({
          type: 'OPEN_SNACKBAR',
          openMensaje: {
            open: true,
            mensaje: 'Se modifico exitosamente la Campaña',
          },
        });
        setCampana({
          id: '',
          CODCAMPANA: 0,
          DESCRICAMPANA: '',
          NUMCAMPANA: '',
          ESTADOCAMPANA: '',
          EMPRESACONTRATADA: '',
          OBJETIVOS: '',
          PRESUPUESTO: 0.0,
        });
        let objetoAudi = {
          usuario: sesionUsuario.usuario.nombrecompleto,
          accion: 'Modificacion',
          panel: 'Marketing',
          tabla: 'CAMPAÑAS',
          filaafectada: props.location.state.clientE_Id,
          UsuarioId: sesionUsuario.usuario.id,
        };
        RegistrarAccion(objetoAudi);
        volver();
      } else {
        dispatch({
          type: 'OPEN_SNACKBAR',
          openMensaje: {
            open: true,
            mensaje: 'Errores al intentar guardar ',
          },
        });
      }
    });
  };
  const volver = () => {
    props.history.goBack();
  };
  useEffect(() => {
    if (mounted.current) {
      setCampana({
        id: props.location.state.campanA_Id,
        CODCAMPANA: props.location.state.codcampana,
        DESCRICAMPANA: props.location.state.descricampana,
        NUMCAMPANA: props.location.state.numcampana,
        ESTADOCAMPANA: props.location.state.estadocampana,
        EMPRESACONTRATADA: props.location.state.empresacontratada,
        OBJETIVOS: props.location.state.objetivos,
        PRESUPUESTO: props.location.state.presupuesto,
      });
      // Comentamos esta linea porque la API debe traer los clientes,
      // no la prop de la localizacion
      // setDataCli(props.location.state.clientesLista);
      setDatag([
        { geografia: 'Local' },
        { geografia: 'Regional' },
        { geografia: 'Nacional' },
        { geografia: 'Internacional' },
      ]);
    }
    return function cleanup() {
      mounted.current = false;
    };
  }, [props]);
  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      {/* Header */}
      <Paper
        elevation={0}
        sx={{
          background: 'linear-gradient(135deg, #1976d2 0%, #0d47a1 100%)',
          borderRadius: 2,
          p: 3,
          mb: 3,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Box
            sx={{
              width: 56,
              height: 56,
              borderRadius: 2,
              background: 'rgba(255,255,255,0.2)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backdropFilter: 'blur(10px)',
            }}
          >
            <CampaignIcon sx={{ fontSize: 32, color: 'white' }} />
          </Box>
          <Box sx={{ flex: 1 }}>
            <Typography variant="h4" sx={{ color: 'white', fontWeight: 600, mb: 0.5 }}>
              Modificar Campaña
            </Typography>
            <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.9)' }}>
              {campana.DESCRICAMPANA}
            </Typography>
          </Box>
        </Box>
      </Paper>

      {/* Formulario */}
      <Paper
        elevation={0}
        sx={{
          p: 3,
          mb: 3,
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 2,
        }}
      >
        <form onSubmit={modificarCampana}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6} sx={{ display: 'none' }}>
              <TextField
                name="CODCAMPANA"
                value={campana.CODCAMPANA}
                fullWidth
                onChange={ingresarValoresMemoria}
                variant="outlined"
                label="Código"
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                name="DESCRICAMPANA"
                value={campana.DESCRICAMPANA}
                fullWidth
                onChange={ingresarValoresMemoria}
                variant="outlined"
                label="Descripción"
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: 2,
                  },
                }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <FormControl variant="outlined" fullWidth>
                <InputLabel>Estado</InputLabel>
                <Select
                  value={estadocampana}
                  onChange={selectEstadohandleChange}
                  label="Estado"
                  sx={{
                    borderRadius: 2,
                  }}
                >
                  <MenuItem value="Activo">Activo</MenuItem>
                  <MenuItem value="Inactivo">Inactivo</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                name="EMPRESACONTRATADA"
                value={campana.EMPRESACONTRATADA}
                fullWidth
                onChange={ingresarValoresMemoria}
                variant="outlined"
                label="Empresa Contratada"
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: 2,
                  },
                }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <FormControl variant="outlined" fullWidth>
                <InputLabel>Geografía</InputLabel>
                <Select
                  value={geografia}
                  onChange={selectGeografiaHandleChange}
                  label="Geografía"
                  sx={{
                    borderRadius: 2,
                  }}
                >
                  <MenuItem value="">Ninguna</MenuItem>
                  {Datag.map((geografia) => (
                    <MenuItem
                      key={geografia.geografia}
                      value={geografia.geografia}
                    >
                      {geografia.geografia}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                name="OBJETIVOS"
                value={campana.OBJETIVOS}
                fullWidth
                onChange={ingresarValoresMemoria}
                variant="outlined"
                label="Objetivos"
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: 2,
                  },
                }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                name="PRESUPUESTO"
                value={campana.PRESUPUESTO}
                fullWidth
                onChange={ingresarValoresMemoria}
                variant="outlined"
                label="Presupuesto"
                type="number"
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: 2,
                  },
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                name="NUMCAMPANA"
                value={campana.NUMCAMPANA}
                onChange={ingresarValoresMemoria}
                fullWidth
                multiline
                rows={4}
                variant="outlined"
                label="Detalles"
                placeholder="Detalles de la campaña"
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: 2,
                  },
                }}
              />
            </Grid>
          </Grid>

          <Box sx={{ display: 'flex', gap: 2, mt: 3, justifyContent: 'flex-end' }}>
            <Button
              variant="outlined"
              startIcon={<ArrowBackIcon />}
              onClick={volver}
              sx={{
                borderRadius: 2,
                px: 3,
                py: 1.5,
                textTransform: 'none',
                fontSize: '1rem',
                fontWeight: 600,
              }}
            >
              Volver
            </Button>
            <Button
              variant="contained"
              startIcon={<SaveIcon />}
              onClick={modificarCampana}
              type="submit"
              sx={{
                borderRadius: 2,
                px: 3,
                py: 1.5,
                textTransform: 'none',
                fontSize: '1rem',
                fontWeight: 600,
                background: 'linear-gradient(135deg, #1976d2 0%, #0d47a1 100%)',
                '&:hover': {
                  background: 'linear-gradient(135deg, #1565c0 0%, #0a3d91 100%)',
                  transform: 'translateY(-2px)',
                  boxShadow: '0 6px 16px rgba(0,0,0,0.2)',
                },
                transition: 'all 0.3s ease',
              }}
            >
              Guardar Cambios
            </Button>
          </Box>
        </form>
      </Paper>

      {/* Botón Clientes Ganados */}
      <Paper
        elevation={0}
        sx={{
          p: 3,
          mb: 3,
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 2,
        }}
      >
        <Button
          variant="contained"
          fullWidth
          startIcon={<PeopleIcon />}
          onClick={mostrarClientes}
          sx={{
            py: 2,
            borderRadius: 2,
            textTransform: 'none',
            fontSize: '1rem',
            fontWeight: 600,
            background: 'linear-gradient(135deg, #4caf50 0%, #2e7d32 100%)',
            '&:hover': {
              background: 'linear-gradient(135deg, #43a047 0%, #1b5e20 100%)',
              transform: 'translateY(-2px)',
              boxShadow: '0 6px 16px rgba(0,0,0,0.2)',
            },
            transition: 'all 0.3s ease',
          }}
        >
          {estadoBotonClientes ? 'Ocultar' : 'Ver'} Clientes Ganados por esta Campaña
        </Button>
      </Paper>

      {/* Tabla de Clientes */}
      {estadoBotonClientes && (
        <Paper
          elevation={0}
          sx={{
            border: '1px solid',
            borderColor: 'divider',
            borderRadius: 2,
            overflow: 'hidden',
          }}
        >
          <TClientes rows={DataCli} termc={''} />
        </Paper>
      )}
    </Container>
  );
}